module.exports = __webpack_public_path__ + "static/media/mail-send.0fc18f45.svg";